import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconDown = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconDown.dimensions.width} ${IconDown.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M.343 1.343 6 7l5.657-5.657"
        stroke={color || Color.premiumBlack}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      />
    </Svg>
  )
}

IconDown.dimensions = {
  width: 12,
  height: 8,
}

export default IconDown
